<template>
  <div class="cointainer">
    <div class="top">
      <div class="leftImg">
        <div class="top">
          <div class="teacher">{{ this.$store.getters.userInfo.name || this.$getUserInfo().name || '老师' }}，您好</div>
          <div class="speak">{{ tipsText }}</div>
          <div class="textClassName">您上次备课至:</div>
          <div class="prePareClass">
            <div class="className" @click="goOnFun(allMess)">
              <a-tooltip placement="top" :title="prepareData.disPlayName">
                <span class="name">{{ prepareData && prepareData.disPlayName || '暂无备课内容' }}</span>
              </a-tooltip>

              <span class="goOn">继续备课</span>
              <img class="img" src="../../assets/homepage/home-next.png" alt=""/>
            </div>
          </div>
        </div>
      </div>
      <div class="right">
        <div class="title">
          <span class="tit">待办事项</span>
        </div>
        <div class="bot">
          <div class="left" @click="goQuestionSolve">
            <img class="img" src="../../assets/homepage/home-question.png" alt="" />
            <div class="text">待解决问题</div>
            <div class="num">{{ replyMess && replyMess.teacherCount }}</div>

          </div>
          <div class="right" @click="goZjhf">
            <img class="img" src="../../assets/homepage/home-reply.png" alt="" />
            <div class="text">专家回复</div>
            <div class="num">{{ replyMess && replyMess.expertCount }}</div>

          </div>
        </div>
      </div>
    </div>
    <div class="task-info">
      <div class="title">
      </div>
      <div class="task-detail">
        <div class="detail-l">
          <div class="d-title">
            <div class="text">
              任务概况
              <div class="title-s">
                <a-select
                    :defaultValue="deafaultClassName"
                    :key="deafaultClassName"
                    size="small"
                    placeholder='请选择班级'
                    style="min-width: 180px;margin-right: 20px"
                    @change="changeTaskClassId"
                >
                  <a-select-option :value="item.id" :label="item.className" v-for="item in classList" :key="item.id">
                    {{ item.className }}
                  </a-select-option>
                </a-select>
                <span class="xs" @click="goTaskMore()">查看更多 </span>
                <img class="more-img" src="@/assets/homepage/21.png" alt="" @click="goTaskMore()"/>
              </div>
            </div>
          </div>
          <div class="d-title-content">
            <!--            <span class="task-name" v-if="lastTaskObj&&lastTaskObj.taskContent">-->
            <!--                <a-tooltip placement="topLeft" :title="lastTaskObj.taskContent">-->
            <!--                  <span v-html="lastTaskObj.taskContent"></span>-->
            <!--                </a-tooltip>-->
            <!--              </span>-->
            <!--            <span v-if="!lastTaskObj.taskContent">暂未发布任务</span>-->
            <!--            <div v-show="lastTaskObjList.length>0" class="chart_stack" id="chart_stack"></div>-->
          </div>
          <div class="d-table">
            <img v-show="lastTaskObjList.length==0" :src="noData" alt=""/>
            <div v-show="lastTaskObjList.length==0">
              <span>暂无任务</span>
              <!--              <span class="fbrw" @click="addTask">发布任务</span>-->
            </div>
            <div v-show="lastTaskObjList.length>0" class="chart_stack" id="chart_stack"></div>
            <!--            <div v-show="lastTaskObjList.length>0" id="chart_rw" class="chart_rw"></div>-->
          </div>
        </div>
        <div class="detail-r">
          <div class="d-title">
            <div class="text">
              学生习题
              <div class="title-s">
                <a-select
                    :defaultValue="(classList&&classList.length>0)?classList[0].className:selectClassName"
                    :key="deafaultClassName"
                    placeholder='请选择班级'
                    size="small"
                    style="min-width: 180px;margin-right: 20px"
                    @change="changeQuestionClassId"
                >
                  <a-select-option :value="item.id" :label="item.className" v-for="item in classList" :key="item.id">
                    {{ item.className }}
                  </a-select-option>
                </a-select>
                <span class="xs"
                      @click="() => {this.$router.push({ name: 'StudentsExercises' })}">查看更多 </span>
                <img class="more-img" src="@/assets/homepage/21.png" alt=""
                     @click="() => {this.$router.push({ name: 'StudentsExercises' })}"/>
              </div>
            </div>
          </div>
          <!--          <div>-->
          <!--            <a-tooltip placement="topLeft" :title="lastPracticeObj.testTitle">-->
          <!--                <span class="task-name">-->
          <!--                  {{ lastPracticeObj && lastPracticeObj.styleName ? lastPracticeObj.styleName : '暂未发布练习题' }}-->
          <!--                </span>-->
          <!--            </a-tooltip>-->

          <!--          </div>-->
          <div class="d-table">
            <img v-show="lastPracticeObj==0" :src="noData" alt=""/>
            <div v-show="lastPracticeObj==0">
              <span>暂无学生提交习题</span>
              <!--              <span class="fbrw" @click="addPractice">添加习题</span>-->
            </div>
            <div v-show="lastPracticeObj!=0" class="chart_circle" id="chart_circle"></div>
            <!--            <div v-show="lastPracticeList.length!=0" id="chart_xt" class="chart_xt"></div>-->
          </div>
        </div>
      </div>
    </div>
    <div class="class-performance">
      <div class="performance-top">
        <div class="bx">班级表现</div>
        <div class="bx-r">
          <div class="class-list">
            <!--                :v-model:value="selectClassPerform"-->
            <!--            :defaultValue="selectClassName"-->
            <a-select
                placeholder='请选择班级'
                :defaultValue="(classList&&classList.length>0)?classList[0].className:selectClassName"
                :key="deafaultClassName"
                size="small"
                style="min-width: 180px;margin-right: 20px"
                @change="handleChange"
            >
              <a-select-option :value="item.id" :label="item.className" v-for="item in classList" :key="item.id">
                {{ item.className }}
              </a-select-option>
            </a-select>
          </div>
          <span class="xs" @click="() => {this.$router.push({ name: 'HomeStudentsDraw' })}">查看学生画像 </span>
          <img class="more-img" src="@/assets/homepage/21.png" alt=""
               @click="() => {this.$router.push({ name: 'HomeStudentsDraw' })}"/>
        </div>
      </div>
      <div class="performance-bottom" v-show="classList&&classList.length>0">
        <!--        <div class="behavioral-path">-->
        <!--          <ul class="behaviourLoadUl">-->
        <!--            <li :class="becurrent == index ? 'beactiveLi' : 'beLi'" v-for="(item, index) in behaviourRoadList"-->
        <!--                :key="index"-->
        <!--                @click="changeBehaviour(item, index)">-->
        <!--              {{ item.name }}-->
        <!--            </li>-->
        <!--          </ul>-->
        <!--          <div class="chart_bar" id="chart_bar"></div>-->
        <!--          &lt;!&ndash;          <div class="xw">行为路径</div>&ndash;&gt;-->
        <!--        </div>-->
        <div class="learning-type">
          <div class="line" id="chart_line"></div>
          <!--          <div class="xw">学习类型</div>-->
        </div>
      </div>
      <a-empty class="performance-empty" v-if="classList===null||classList.length==0"/>
    </div>
    <div class="videoBot">
      <div class="left">
        <div class="title" @click="lookMoreVideo">
          <span class="tit">蜗牛视频</span>
          <span class="more">查看更多 >></span>
        </div>
        <ul class="activeList">
          <li :class="item.isFree===0?'activeLi':'activeLiLock'" v-for="(item,index) in videoList" :key="index"
              @click="lookSnailVideo(item)">
            <!--            <div class="readText">{{ item.title }}</div>-->
            <!--            <div class="readText">-->
            <!--              <div class="look">{{ item.playCount }}浏览</div>-->
            <!--              <div class="look">立即查看</div>-->
            <!--            </div>-->

            <div class="imgDetail">
              <img class="imgTop"
                   :src="(item&&item.fileList&&item.fileList.length>0)?resBasePath+'/'+item.fileList[0].coverPath:mrImg"
                   alt=""/>
              <!--              <img class="imgTop" :src="item.fileList==null?mrImg:resBasePath+'/'+item.fileList[0].coverPath" alt=""/>-->
              <!--              <span class="beginStaus"></span>-->
              <img v-if="item.isFree === 1" src="../../assets/image/lock.png" :class="{ lock: true}"/>
            </div>
            <ul class="activeDesc">
              <li>
                <span class="title">{{ item.title }}</span>
                <!--                <span class="free">免费</span>-->
              </li>
              <li>
                <a-tooltip placement="top" :title="item.authorInfo">
                  <div class="titleName">{{ item.author }} {{ item.authorInfo }}</div>
                </a-tooltip>
              </li>
              <li style="margin-top: 10px">
                <a-icon type="eye"/>
                <span class="watchNum">{{ item.playCount }}次浏览</span>
                <!--                <span class="watchNum">{{format.liveType(item.liveType)}}</span>-->
                <a-button :class="item.isFree===0?'watchNow':'watchNowLock'" :disabled="item.isFree===1"
                          @click="lookSnailVideo(item)">立即查看
                </a-button>
              </li>
            </ul>
          </li>

        </ul>
      </div>
      <div class="right1">
        <div class="title">
          <span class="tit">蜗牛文章</span>
          <span class="more" @click="lookSnailBook">查看更多 >></span>
        </div>
        <ul v-if="bookList.length>0" class="contentUl">
          <!--          <li class="ulLi" v-for="(item,index) in bookList" :key="index">-->
          <!--            <img class="tb" src="../../assets/teacherRoad/14.png" alt=""/>-->
          <!--            <span class="kb">课标</span>-->
          <!--            <span class="text">{{ item.title }}</span>-->
          <!--            <span class="author">{{ item.authorName }}</span>-->
          <!--            <span class="look" @click="lookDetail(item)">查看</span>-->
          <!--          </li>-->
          <li :class="item.isFree===0?'bookDetail':'bookDetailLock'" v-for="(item,index) in bookList" :key="index"
              @click="lookDetail(item)">
            <div class="arcticle">
              <img class="arcicle-icon" src="../../assets/image/ic_teacher_jiaoxue.jpg" alt="Lock Icon"
                   v-if="item.articleType===1"/>
              <img class="arcicle-icon" src="../../assets/image/ic_teacher_gaokao.png" alt="Lock Icon"
                   v-if="item.articleType===2"/>
              <img class="arcicle-icon" src="../../assets/image/ic_teacher_jiaoxue.jpg" alt="Lock Icon"
                   v-if="item.articleType===3"/>
              <img class="arcicle-icon" src="../../assets/image/ic_teacher_sheji.jpg" alt="Lock Icon"
                   v-if="item.articleType===4"/>
              <img class="arcicle-icon" src="../../assets/image/ic_teacher_kecheng.jpg" alt="Lock Icon"
                   v-if="item.articleType===5"/>
              <img class="arcicle-icon" src="../../assets/image/ic_teacher_shisheng.png" alt="Lock Icon"
                   v-if="item.articleType===6"/>
              <img class="arcicle-icon" src="../../assets/image/ic_teacher_wenben.png" alt="Lock Icon"
                   v-if="item.articleType===7"/>
              <img class="arcicle-icon" src="../../assets/image/ic_teacher_xiezuo.jpg" alt="Lock Icon"
                   v-if="item.articleType===8"/>
              <div class="arcticle-detail">
                <div class="title">{{ item.title }}</div>
                <div class="time">
                  <img class="userPhoto" src="../../assets/image/ic_teacher_time.png" alt=""/>
                  <span class="date">{{ format.format(item.createDate) }}</span>
                </div>
                <div class="author">
                  <img class="userPhoto" src="../../assets/image/ic_teacher_name.png" alt=""/>
                  <span class="userName">{{ item.authorName }}</span>
                </div>
                <!-- <img class="classImg" src="../../assets/teacherRoad/14.png" alt="" />
                <span class="classType">{{format.articleType(item.articleType)}}</span> -->
              </div>
            </div>
            <!-- <div class="content" v-html="item.content"></div> -->

            <div class="overlay" v-if="item.isFree===1"></div>
            <img class="lock-icon" src="../../assets/image/lock.png" alt="Lock Icon" v-if="item.isFree===1"/>
          </li>
        </ul>
        <ul v-if="bookList.length<=0" class="contentUl">
          <li class="no-text">暂无数据</li>
        </ul>
      </div>
    </div>
    <!-- 角色选择-->
    <a-modal title="选择角色" width="400px" @cancel="classNoticeVis = false" :visible="classNoticeVis" footer="">
      <template>
        <div>
          <a-radio-group v-model="value" @change="onChange">
            <a-radio class="radio" :value="1">教师角色</a-radio>
            <a-radio class="radio" :value="2">学生角色</a-radio>
          </a-radio-group>
        </div>
        <div class="f-del">
          <div class="f-c" @click="() => { this.classNoticeVis = false;}">取消</div>
          <div class="f-s" @click="classNoticeOk">确认</div>
        </div>
      </template>
    </a-modal>
  </div>
</template>

<script>
import requestUrl from '../../utils/requestUrl'
import shareState from '../../utils/shareState.js'
import format from '@/utils/format.js'
import WebIM from '../../utils/WebIM'
import { getHomeRadarOption } from '../../utils/echartsOption'

export default {
  name: 'HomePage',
  watch: {
    dataType () {
      this.getChartData(this.selectClassPerform)
    }
  },
  data () {
    return {
      format,
      userId: localStorage.getItem('userId'),
      access_token: localStorage.getItem('access_token'),
      videoList: [], // 蜗牛视频
      bookList: [], // 蜗牛文章
      replyMess: {}, // 专家回复
      allMess: {},
      timer: null, // 轮询查询数量
      prepareData: {},
      lastTaskObj: {}, // 近期任务
      lastTaskObjList: [], // 近期任务列表
      lastPracticeObj: 0, // 练习对象
      lastPracticeList: [], // 练习列表
      currentClassIndex: 0,
      currentClassIndex1: 0,
      classList: [], // 班级
      classImg: require('@/assets/image/class.png'),
      classImg2: require('@/assets/image/class.png'),
      noData: require('@/assets/image/no-data.png'),
      becurrent: 0,
      taskName: ['任务一', '任务二', '任务三', '任务四', '任务五', '任务六', '任务七', '任务八', '任务九', '任务十'],
      beaviourList: [
        { name: '班级平均表现', key: 0 },
        { name: '优秀表现', key: 1 }
      ],
      behaviourRoadList: [
        { name: '被动行为', key: 'read' },
        { name: '主动行为', key: 'label' },
        { name: '构建行为', key: 'build' },
        { name: '交互行为', key: 'mutual' }
      ],
      dataType: 'read', // 行为类型
      selectClassPerform: '', // 行为类型
      selectClassName: '暂无班级', // 行为类型
      resBasePath: this.$resBasePath,
      mrImg: require('@/assets/imgs/video.png'),
      color: ['#17CE74', '#FFD300', '#FF5F4C', '#32C1FF', '#8E83E7', '#FFAB45', '#578EEF'],
      chartColor: ['#60AEF8', '#D5EB5C', '#23C6DB', '#6CD2B6', '#8E83E7', '#FBB655', '#FC806B'],
      // 角色选择
      classNoticeVis: false,
      value: 1,
      roleValue: 1,
      deafaultClassName: '',
      tipsText: '闻见广则聪明辟，胜友之而学易成。',
      shareData: shareState.state
    }
  },
  mounted () {
    sessionStorage.setItem('routeIndex', 0)
    this.getBooks()
    this.getAll()
    // this.getVideoList()
    this.getMediaPage()
    this.getBookList()
    this.getTeacherAskAndExpertReplyCount()
    this.getLessonRecords()
    this.getSimpleClaList()
    this.textTips()
  },
  created () {
    // 只弹出一次的角色选择框
    const item = sessionStorage.getItem('homeRoledialog')
    if (item !== '1') {
      sessionStorage.setItem('homeRoledialog', '1')
      this.showRoleDialog()
    }
    // 环信登录
    this.getImInfo()
  },

  methods: {
    textTips () {
      const array = [
        { id: 0, name: '没有爱，就没有教育。——苏霍姆林斯基' },
        { id: 1, name: '善于鼓舞学生，是教育中最宝贵的经验。——苏霍姆林斯基' },
        { id: 2, name: '一个无任何特色的教师，他教育的学生不会有任何特色。——苏霍姆林斯基' },
        { id: 3, name: '一个好的教师，是一个懂得心理学和教育学的人。——苏霍姆林斯基' },
        { id: 4, name: '好的先生不是教书，不是教学生，乃是教学生学。——陶行知' },
        { id: 5, name: '捧着一颗心来，不带半根草去。——陶行知' },
        { id: 6, name: '要把学生造就成一种什么人，自己就应当是什么人。——车尔尼雪夫斯基' },
        { id: 7, name: '师也者，教之以事而喻诸德也。——《礼记·文王世子》' },
        { id: 8, name: '教师之为教，不在全盘授予，而在相机诱导。——叶圣陶' },
        { id: 9, name: '唯有老师善读善写，乃能导引学生渐进于善读善写。——叶圣陶' },
        { id: 10, name: '教育是什么？往简单方面说，只须一句话，就是养成良好的习惯。——叶圣陶' },
        { id: 11, name: '不愤不启，不悱不发。——《论语·述而》' },
        { id: 12, name: '教育不是注满一桶水，而是点燃一把火。——叶芝' },
        { id: 13, name: '学然后知不足，教然后知困。——《礼记·学记》' }
      ]
      const newNumber = Math.floor(Math.random() * 13)
      this.tipsText = array[newNumber].name
    },
    getBooks () {
      this.$fetch({
        url: this.$baseUrl + 'ebook/book/myBookList',
        body: {
          purchaseVersion: 2
        }
      }).done(res => {
        // this.books = res.resultData.list
        //  this.bookId = this.books[0].id
        localStorage.setItem('syzg-bookId', 1)
        this.$store.commit('setMyBookList', res.resultData.list)
        // this.isPurchase()
      })
    },
    getLessonRecords () {
      const param = {
        userId: this.userId,
        access_token: this.access_token
      }
      this.$fetch({
        url: this.$baseUrl + 'ebook/teacher/lessonBook/getLessonRecords',
        body: param
      }).done(res => {
        if (res && res.success && res.resultCode == 0) {
          this.prepareData = res.resultData || {}
          localStorage.setItem('beikeBookId', this.prepareData.bookId)
        }
      })
    },
    startTimer () {
      this.timer = setInterval(() => {
        setTimeout(() => {
          this.getTeacherAskAndExpertReplyCount()
        }, 10)
      }, 50000)
    },
    getAll () {
      this.$fetch({
        url: this.$baseUrl + 'ebook/teacher/homePage/getAll',
        body: {}
      }).done(res => {
        if (res && res.success && res.resultCode == 0) {
          this.allMess = res.resultData.lessonPrepare
          if (this.allMess && this.allMess.styleId) {
            localStorage.setItem('styleId', this.allMess.styleId)
          }
        }
      })
    },
    // 视频列表/ebook/teacher/live/getMediaCategoryList
    getVideoList () {
      this.$fetch({
        url: this.$baseUrl + 'ebook/teacher/live/getMediaPage',
        body: {
          mediaCategoryId: '',
          isPayment: 0,
          pageSize: 4,
          pageNum: 1
        }
      }).done(res => {
        if (res && res.success && res.resultCode === 0) {
          this.videoList = res.resultData.list
        }
      })
    },
    lookMoreVideo () {
      // 查看更多蜗牛视频
      sessionStorage.setItem('videoPageNum', 0)
      this.$router.push({ name: 'newSnailLive' })
      sessionStorage.setItem('routeIndex', 3)
    },
    lookVideoDetai (item) { // 蜗牛视频查看详情

    },
    // 蜗牛文章 ebook/teacher/article/getArticleList
    getBookList () {
      const _this = this
      _this.$fetch({
        url: _this.$baseUrl + 'ebook/teacher/article/getArticleList',
        body: {
          pageSize: 4,
          pageNum: 1,
          articleType: ''
        }
      }).done(res => {
        if (res && res.success && res.resultCode == 0) {
          if (res.resultData && res.resultData.list) {
            _this.bookList = res.resultData.list
          }
        }
      })
    },
    // 获取待解决问题 ebook/teacher/ask/getTeacherAskAndExpertReplyCount
    getTeacherAskAndExpertReplyCount () {
      this.$fetch({
        url: this.$baseUrl + 'ebook/teacher/ask/getTeacherAskAndExpertReplyCount',
        body: {
          userId: this.userId
        }
      }).done(res => {
        if (res && res.success && res.resultCode === 0) {
          this.replyMess = res.resultData
        }
      })
    },
    goOnFun (item) {
      localStorage.setItem('styleId', item.styleId)
      localStorage.setItem('disPlayName', this.prepareData.orgDisplayName || '')
      if (!item) {
        this.$message.warning('暂无备课内容')
      } else {
        this.$router.push({ path: `/books/attainment/${item.styleId}` })
      }
      sessionStorage.setItem('routeIndex', 1)
      //  console.log('备课内容' + this.prepareData.orgDisplayName)
    },
    goTaskMore () {
      if (this.allMess && this.allMess.styleId) {
        localStorage.setItem('styleId', this.allMess.styleId)
        this.$router.push({ path: 'books/studyTask' })
        sessionStorage.setItem('routeIndex', 1)
      } else {
        this.$message.warning('暂无任务内容')
      }
    },
    lookSnailVideo (item) {
      // this.$router.push({name: 'snailVideoList'})
      if (item.isFree === 0) {
        sessionStorage.setItem('routeIndex', 3)
        sessionStorage.setItem('videoDetail', JSON.stringify(item))
        this.$router.push({ name: 'snailVideoDetail' })
      } else {
        this.$message.warning('请开通教材后观看')
      }
    },
    lookSnailBook () {
      this.$router.push({ name: 'snailBookList' })
      sessionStorage.setItem('routeIndex', 3)
    },
    lookDetail (item) {
      if (item.isFree === 0) {
        sessionStorage.setItem('routeIndex', 3)
        sessionStorage.setItem('snailsID', item.id)
        // this.$router.push({ path: 'snailBookListDetail' })
        this.$router.push({ name: 'snailBookListDetail' })
      } else {
        this.$message.warning('请开通教材后查看')
      }
    },
    goQuestionSolve () { // 跳转到陪伴助学
      sessionStorage.setItem('routeIndex', 0)
      this.$router.push({ name: 'QuestionSolve' })
    },
    goZjhf () { // 专家回复
      sessionStorage.setItem('routeIndex', 0)
      this.$router.push({ name: 'ExpertReply' })
    },
    /**
     * 获取班级成员
     */
    getSimpleClaList () {
      // 获取班级成员
      this.$http.post(requestUrl.getSimpleClaList, {
        access_token: this.access_token,
        userId: this.userId
      }).then((res) => {
        if (res) {
          this.classList = res
          this.deafaultClassName = (this.classList && this.classList.length > 0) ? this.classList[0].className : this.selectClassName
          //  console.log('deafaultClassName', this.deafaultClassName)
          if (this.classList.length > 0) {
            this.selectClassPerform = this.classList[0].id
            this.selectClassName = this.classList[0].className
            this.getTaskStatistics(this.classList[0].id)
            this.getExerciseStatistics(this.classList[0].id)
            this.getChartData(this.classList[0].id)
          }
        }
      })
    },
    /**
     * 统计获取课程任务的学生回答数量
     */
    getTaskStatistics (clsaaId) {
      // 获取班级成员
      this.$http.post(requestUrl.getHomepageTaskStatistics, {
        access_token: this.access_token,
        classId: clsaaId,
        userId: this.userId
      }).then((res) => {
        if (res) {
          this.lastTaskObjList = res.taskStatisticsList
          const series = []

          //  console.log('lastTaskObjList', this.lastTaskObjList)
          //  console.log('taskStatisticsList', this.taskName.splice(0, res.taskStatisticsList.length))
          const taskClassName = ['任务一', '任务二', '任务三', '任务四', '任务五', '任务六', '任务七', '任务八', '任务九', '任务十']
          const tactName = ['活动一', '活动二', '活动三', '活动四', '活动五', '活动六', '活动七', '活动八', '活动九', '活动十']
          const currentTaskName = taskClassName.splice(0, this.lastTaskObjList.length)

          //  console.log('currentTaskName', currentTaskName)

          //  const arr = [[1, 2, 3], [4, 5, 6], [7, 8, 9], [10, 11, 12], [13, 14, 15]]
          //  const arr2 = [{ activityList: [{ count: 1 }, { count: 2 }, { count: 3 }] }, { activityList: [{ count: 4 }, { count: 5 }, { count: 6 }] }, { activityList: [{ count: 7 }, { count: 8 }, { count: 9 }] }, { activityList: [{ count: 10 }, { count: 11 }, { count: 12 }] }, { activityList: [{ count: 13 }, { count: 14 }, { count: 15 }] }]
          //  const result = arr[0].map((_, i) => arr.map(item => item[i]))
          //  console.log(result)
          // 将服务器返回格式转化为echarts要求的格式
          const result = res.taskStatisticsList.reduce((acc, item) => {
            if (item.activityList != null && acc != undefined) {
              item.activityList.forEach((subItem, i) => {
                if (!acc[i]) {
                  acc[i] = []
                }
                acc[i].push(subItem.count)
              })
              return acc
            } else {
              return []
            }
          }, [])
          //  console.log(result)
          result.forEach((item, i) => {
            series.push({
              name: tactName[i],
              type: 'bar',
              stack: 'x',
              data: item,
              barMaxWidth: 40, // 每一个都要设置
              barMinWidth: 10, // 每一个都要设置
              itemStyle: {
                borderWidth: 10
              }
            })
          })
          const currenttActName = tactName.splice(0, result.length)
          //  console.log('currenttActName', currenttActName)
          const chartStack = this.$echarts.init(document.getElementById('chart_stack'))
          const option = {
            color: this.chartColor,
            title: {
              text: res.lesson.disPlayName + '任务提交情况',
              left: 'center',
              top: 'top',
              textStyle: {
                fontSize: 13
              }
            },
            label: {
              show: true
            },
            tooltip: {
              trigger: 'axis',
              axisPointer: {
                type: 'shadow'
              }
            },
            legend: {
              show: true,
              // data: ['活动一', '活动二', '活动三', '活动四', '活动五', '活动六', '活动七', '活动八', '活动九', '活动十'],
              data: currenttActName,
              orient: 'horizontal',
              left: 'center',
              bottom: 'bottom',
              textStyle: {
                fontSize: 12,
                color: '#000'
              }
            },
            xAxis: {
              data: currentTaskName
              // data: ['任务一', '任务二', '任务三']
            },
            yAxis: {
              // minInterval: 1,
              // axisLabel: {
              //   formatter: '{value}'
              // }
            },
            series: series
          }
          chartStack.setOption(option)
        }
      })
    },
    /**
     * 统计获取课程习题的学生回答数量
     */
    getExerciseStatistics (clsaaId) {
      // 获取班级成员
      this.$http.post(requestUrl.getHomepageExerciseStatistics, {
        access_token: this.access_token,
        classId: clsaaId,
        userId: this.userId
      }).then((res) => {
        if (res) {
          this.lastPracticeObj = res.commitCount + res.notCommitCount
          const chartCircle = this.$echarts.init(document.getElementById('chart_circle'))
          const option = {
            color: this.color,
            tooltip: {
              trigger: 'item',
              formatter: '{b}: {c} ({d}%)'
            },
            label: {
              show: true,
              overflow: 'none',
              position: 'left' // 标签显示在左侧
            },
            title: {
              text: res.lesson.disPlayName + '习题提交情况',
              left: 'center',
              top: 'top',
              textStyle: {
                fontSize: 13
              }
            },
            legend: {
              show: true,
              orient: 'horizontal',
              left: 'center',
              bottom: 'bottom',
              textStyle: {
                fontSize: 14,
                color: '#000'
              }
            },
            series: [
              {
                type: 'pie',
                data: [
                  {
                    value: res.commitCount,
                    name: '已提交',
                    label: { position: [1, 0] }
                  },
                  {
                    value: res.notCommitCount,
                    name: '未提交',
                    label: { position: [1, 0] }
                  }
                ],
                radius: ['50%', '65%']
              }
            ]
          }
          chartCircle.setOption(option)
        }
      })
    },
    /**
     * 获取视频列表
     */
    getMediaPage () {
      // 获取班级成员
      this.$http.post(requestUrl.getMediaPage, {
        access_token: this.access_token,
        mediaCategoryId: '',
        userId: this.userId,
        pageSize: 4,
        pageNum: 1
      }).then((res) => {
        if (res) {
          this.videoList = res.list
          //  console.log('视频列表', this.videoList[0].fileList[0].coverPath)
          //  console.log('视频列表', this.videoList)
        }
      })
    },
    changeTaskClassId (e) {
      // this.currentClassIndex1 = index
      // this.classId = item.id
      // this.getChartData()
      // this.getWorkStatistics()
      // this.getTestStatistics()
      // 任务概况-班级选择
      this.getTaskStatistics(e)
    },
    changeQuestionClassId (e) {
      // this.currentClassIndex = index
      // this.classId = item.id
      // 学生习题-班级选择
      this.getExerciseStatistics(e)
    },
    changeBehaviour (item, index) {
      this.becurrent = index
      this.dataType = item.key
    },
    addTask () {
      sessionStorage.setItem('routeIndex', 1)
      this.$router.push({ name: 'StudyTask' })
    },
    addPractice () {
      sessionStorage.setItem('routeIndex', 1)
      this.$router.push({ name: 'practice' })
    },
    handleChange (e) {
      //  console.log(e)
      this.selectClassPerform = e
      this.getChartData(e)
    },
    getChartData (classId) {
      // 班级单元数据
      // this.studyTypeStatisticsUnit(classId)
      // 雷达图
      this.studyTypeStatistics(classId)
    },
    studyTypeStatisticsUnit (classId) {
      const _this = this
      const param = {
        bookId: '1',
        classId: classId,
        classIds: [this.classId], // '219eb8973d4c48fe8102bb4d96df29b7'
        studentIds: [],
        token: this.access_token,
        type: 1,
        userId: this.userId,
        access_token: this.access_token
      }
      this.$http.post(requestUrl.getHomePageStatistics, param)
        .then(res => {
          if (res) {
            const data = res

            const read = data.read
            const label = data.label
            const build = data.build
            const mutual = data.mutual
            //  console.log(data)
            //  console.log(read)
            //  console.log(label)

            //  this.columns = read.yRes[0].tableData
            const series = []
            // let dataBuild = []
            const dataStar = []
            const dataStarSeries = []
            switch (this.dataType) {
              case 'read':
                //  dataBuild = read.xRes
                // 柱状图数据
                read.yRes.forEach((item) => {
                  series.push({
                    name: item.name,
                    type: 'bar',
                    data: item.data
                  })
                  // 雷达图图例标记
                  dataStar.push(item.name)
                  dataStarSeries.push({
                    name: item.name,
                    value: item.data,
                    symbolSize: 2.5,
                    itemStyle: {
                      normal: {
                        borderColor: '#f9cf67',
                        borderWidth: 2.5
                      }
                    }
                  })
                })
                // this.tableData = data.read.yRes
                break
              case 'build':
                //  dataBuild = data.build.xRes
                data.build.yRes.forEach((item) => {
                  series.push({
                    name: item.name,
                    type: 'bar',
                    data: item.data
                  })
                  dataStar.push(item.name)
                  dataStarSeries.push({
                    name: item.name,
                    value: item.data,
                    symbolSize: 2.5,
                    itemStyle: {
                      normal: {
                        borderColor: '#f9cf67',
                        borderWidth: 2.5
                      }
                    }
                  })
                })
                this.tableData = data.build.yRes
                break
              case 'mutual':
                //  dataBuild = data.mutual.xRes
                data.mutual.yRes.forEach((item) => {
                  series.push({
                    name: item.name,
                    type: 'bar',
                    data: item.data
                  })
                  dataStar.push(item.name)
                  dataStarSeries.push({
                    name: item.name,
                    value: item.data,
                    symbolSize: 2.5,
                    itemStyle: {
                      normal: {
                        borderColor: '#f9cf67',
                        borderWidth: 2.5
                      }
                    }
                  })
                })
                this.tableData = data.build.yRes
                break
              case 'label':
                //  dataBuild = data.label.xRes
                data.label.yRes.forEach((item) => {
                  series.push({
                    name: item.name,
                    type: 'bar',
                    data: item.data
                  })
                  dataStar.push(item.name)
                  dataStarSeries.push({
                    name: item.name,
                    value: item.data,
                    symbolSize: 2.5,
                    itemStyle: {
                      normal: {
                        borderColor: '#f9cf67',
                        borderWidth: 2.5
                      }
                    }
                  })
                })
                this.tableData = data.label.yRes
                break
            }

            // console.log(this.tableData);
            // this.tableData.forEach((o) => {
            //   o.tableData.forEach((p) => {
            //     // 被动行为 秒转小时处理
            //     p.count = this.dataType === 'read' ? (p.count / 3600).toFixed(1) : p.count.toFixed(2)
            //   })
            // })
            series.forEach((o) => {
              o.data.forEach((p, idx) => {
                // 被动行为 秒转小时处理
                o.data[idx] = this.dataType === 'read' ? (p / 3600).toFixed(1) : p.toFixed(2)
              })
            })

            const chartBar = this.$echarts.init(document.getElementById('chart_bar'))
            const optionBar = {
              color: this.color,
              // dataZoom: [
              //   {
              //     type: 'inside', // slider表示有滑动块的，inside表示内置的
              //     backgroundColor: 'rgba(216,165,101,0.2)',
              //     fillerColor: 'rgba(216,165,101,0.4)', // 选中范围的填充颜色。
              //     borderColor: '#ddd',
              //     show: true,
              //     xAxisIndex: [0],
              //     start: 0,
              //     end: 80
              //   }
              // ],
              tooltip: {
                trigger: 'axis',
                axisPointer: {
                  type: 'shadow'
                },
                // 行为路径 柱状图
                // 使用 formatter 函数自定义显示的内容
                formatter: function (params) {
                  // params 是包含数据信息的对象
                  //  console.log(params)
                  var unit = '次'
                  if (_this.dataType === 'read') {
                    unit = '小时'
                  }
                  // 显示的内容

                  var content = params[0].name + '<br/>'
                  // 遍历数据项，构建显示内容
                  params.forEach(function (item) {
                    var colorSpan = '<span style="display:inline-block;margin-right:5px;width:10px;height:10px;border-radius:50%;background-color:' + item.color + '"></span>'
                    content += colorSpan + item.seriesName + ' : ' + item.value + unit + '<br/>'
                  })
                  return content
                }
              },
              grid: {
                left: '0%',
                right: '0%',
                bottom: '10%',
                top: '10%',
                containLabel: true
              },
              calculable: true,
              legend: {
                data: dataStar, // 被动行为
                // y: '5px', // 图例说明文字设置
                // x: '0px',
                orient: 'horizontal',
                left: 'center',
                bottom: 'bottom',
                textStyle: {
                  fontSize: 14,
                  color: '#000'
                }
              },
              xAxis: [
                {
                  type: 'category',
                  axisTick: { show: false },
                  axisLine: { show: false },
                  axisLabel: {
                    show: true,
                    interval: 0,
                    formatter: function (value) {
                      var ret = '' // 拼接加\n返回的类目项
                      var maxLength = 4 // 每项显示文字个数
                      var valLength = value.length // X轴类目项的文字个数
                      var rowN = Math.ceil(valLength / maxLength) // 类目项需要换行的行数
                      if (rowN > 1) {
                        // 如果类目项的文字大于4,
                        for (var i = 0; i < rowN; i++) {
                          var temp = '' // 每次截取的字符串
                          var start = i * maxLength // 开始截取的位置
                          var end = start + maxLength // 结束截取的位置
                          // 这里也可以加一个是否是最后一行的判断，但是不加也没有影响，那就不加吧
                          temp = value.substring(start, end) + '\n'
                          ret += temp // 凭借最终的字符串
                        }
                        return ret
                      } else {
                        return value
                      }
                    },
                    textStyle: {
                      color: '#000', // X轴文字颜色
                      padding: [0, 0, 0, 0],
                      fontSize: 14
                    }
                  },
                  data: data.read.xRes
                }
              ],
              yAxis: [
                {
                  type: 'value',
                  axisLine: { show: false },
                  axisTick: { show: false }
                }
              ],
              series: series
            }
            chartBar.setOption(optionBar)

            // 雷达图数据初始化
            this.behaviorArray = []
            read.yRes.forEach((item, index) => {
              const obj = {}
              const name = read.yRes[index].name
              const value = []
              value[0] = (read.yRes[index].collectSum / 3600).toFixed(1) // 秒转小时处理
              value[1] = label.yRes[index].collectSum.toFixed(2)
              value[2] = build.yRes[index].collectSum.toFixed(2)
              value[3] = mutual.yRes[index].collectSum.toFixed(2)
              obj.name = name
              obj.value = value
              this.behaviorArray.push(obj)
            })

            // const chartStar = this.$echarts.init(document.getElementById('chart_line'))
            // const optionStar = {
            //   color: this.color,
            //   backgroundColor: '#fff',
            //   legend: {
            //     show: true,
            //     // icon: 'circle',//图例形状
            //     overflow: 'none',
            //     orient: 'horizontal',
            //     left: 'center',
            //     bottom: 'bottom',
            //     itemWidth: 14, // 图例标记的图形宽度。[ default: 25 ]
            //     itemHeight: 14, // 图例标记的图形高度。[ default: 14 ]
            //     itemGap: 21, // 图例每项之间的间隔。[ default: 10 ]横向布局时为水平间隔，纵向布局时为纵向间隔。
            //     textStyle: {
            //       fontSize: 14,
            //       color: '#000'
            //     },
            //     data: dataStar
            //   },
            //   grid: {
            //     left: '0%',
            //     right: '0%',
            //     bottom: '10%',
            //     top: '10%',
            //     containLabel: true
            //   },
            //   tooltip: {
            //     show: true,
            //     trigger: 'item',
            //     // 行为路径雷达图
            //     // 使用 formatter 函数自定义显示的内容
            //     formatter: function (params) {
            //       // params 是包含数据信息的对象
            //       //  console.log(params)
            //       var value = params.value
            //       var indicator = _this.behaviourRoadList
            //       var tooltipContent = ''
            //       var colorSpan = '<span style="display:inline-block;margin-right:5px;width:10px;height:10px;border-radius:50%;background-color:' + params.color + '"></span>'
            //       for (var i = 0; i < indicator.length; i++) {
            //         var unit = '次'
            //         if (i === 0) {
            //           unit = '小时'
            //         }
            //         tooltipContent += indicator[i].name + ': ' + value[i] + unit + '<br/>'
            //       }
            //       return colorSpan + params.name + '<br/>' + tooltipContent
            //     }
            //   },
            //   radar: [
            //     {
            //       indicator: [
            //         {
            //           text: '被动行为',
            //           min: 0,
            //           axisLabel: { show: true }
            //         },
            //         {
            //           text: '主动行为',
            //           axisLabel: { show: true },
            //           min: 0
            //         },
            //         {
            //           text: '构建行为',
            //           axisLabel: { show: true },
            //           min: 0
            //         },
            //         {
            //           text: '交互行为',
            //           axisLabel: { show: true },
            //           min: 0
            //         }
            //       ],
            //       textStyle: {
            //         color: 'red'
            //       },
            //       center: ['50%', '50%'],
            //       radius: 142,
            //       startAngle: 90,
            //       splitNumber: 5,
            //       orient: 'horizontal', // 图例列表的布局朝向,默认'horizontal'为横向,'vertical'为纵向.
            //       name: {
            //         formatter: '{value}',
            //         textStyle: {
            //           fontSize: 10, // 外圈标签字体大小
            //           color: '#000' // 外圈标签字体颜色
            //         }
            //       },
            //       splitArea: {
            //         // 坐标轴在 grid 区域中的分隔区域，默认不显示。
            //         show: true,
            //         areaStyle: {
            //           // 分隔区域的样式设置。
            //           // 分隔区域颜色。分隔区域会按数组中颜色的顺序依次循环设置颜色。默认是一个深浅的间隔色。
            //           color: ['rgba(250, 250, 250, 0.2)', 'rgba(210, 219, 238, 0.2)']
            //         }
            //       },
            //       axisLabel: {
            //         // 展示刻度
            //         show: true
            //       },
            //       axisLine: {
            //         // 指向外圈文本的分隔线样式
            //         lineStyle: {
            //           color: '#e0e0e0'
            //         }
            //       },
            //       splitLine: {
            //         lineStyle: {
            //           color: '#e0e0e0', // 分隔线颜色
            //           width: 1 // 分隔线线宽
            //         }
            //       }
            //     }
            //   ],
            //   series: [
            //     {
            //       name: '雷达图',
            //       type: 'radar',
            //       itemStyle: {
            //         emphasis: {
            //           lineStyle: {
            //             width: 5
            //           }
            //         }
            //       },
            //       data: this.behaviorArray
            //       // color: this.color
            //     }
            //   ]
            // }
            // chartStar.setOption(optionStar)
          }
        })
    },
    studyTypeStatistics (classId) {
      // 学习类型
      const _this = this
      const classIds = []
      classIds.push(classId)
      this.$fetch({
        url: _this.$baseUrl + 'ebook/teacher/statistics2/studyTypeStatisticsByStyleId',
        body: {
          bookId: _this.prepareData.bookId,
          token: _this.access_token,
          styleId: _this.prepareData.styleId,
          classIds: classIds,
          // type：1 班级（默认）， 2 学生
          type: 1
        }
      }).done((res) => {
        if (res && res.success && res.resultCode === 0) {
          const dataSeries = res.resultData || []
          const radarOption = getHomeRadarOption(dataSeries)
          setTimeout(() => {
            const chartStar = _this.$echarts.init(document.getElementById('chart_line'))
            chartStar.setOption(radarOption)
          }, 200)
        }
      })
    },

    showRoleDialog () {
      // 增加小球，去掉进入显示角色选择弹窗
      // const roleList = this.$getUserInfo().roleList
      // // 判断数组中是否同时包含teacher和student
      // if (roleList.some(item => item.roleName === 'ROLE_TEACHER_ENT') && roleList.some(item => item.roleName === 'ROLE_LEARNER_ENT')) {
      //   // 如果同时包含teacher和student，则弹出提示框
      //   this.classNoticeVis = true
      // }
    },
    classNoticeOk () {
      this.classNoticeVis = false
      if (this.roleValue === 1) {
        // 教师角色
      } else {
        // 学生角色
        // window.location.href = this.$baseUrl + 'stu'
        window.location.replace(this.$loginStudentUrl)
      }
    },
    onChange (e) {
      //  console.log('radio checked', e.target.value)
      this.roleValue = e.target.value
    },
    getImInfo () {
      // //  console.log('登陆环信1', 'getImInfo')
      // 获取用户IM注册信息
      if (this.shareData.imUserInfo) {
        //  //  console.log('登陆环信2', 'getImInfo-loginWebIm-' + this.shareData.imUserInfo)
        this.loginWebIm()
        //  //  console.log('登陆环信3', 'getImInfo-loginWebIm')
        return
      }
      // //  console.log('登陆环信4', 'getImInfo')
      // //  console.log('登陆环信5', this.shareData.imUserInfo)

      const param = {
        access_token: this.access_token,
        userId: this.userId
      }
      this.$http.post(requestUrl.getUserLoginToken, param).then(res => {
        if (res) {
          shareState.setImUserInfo({
            access_token: res.access_token,
            expires_in: res.expires_in,
            user: res.user
          })
          // console.log('登陆环信6', this.shareData.imUserInfo)
          this.loginWebIm()
        }
      })
    },
    showLoginAnother () {
      //  console.log('异地登陆', 'showLoginAnother')
      const vm = this
      vm.$confirm({
        title: '异地登录提示',
        content: '账号在其他设备登录，请重新登录',
        cancelButtonProps: { style: { display: 'none' } },
        onOk () {
          window.localStorage.clear()
          sessionStorage.clear()
          localStorage.clear()
          // vm.$router.push({ name: 'Login' })
          //  console.log(process.env.NODE_ENV)
          window.location.replace(vm.$loginUrl)
        }
      })
    },
    loginWebIm () {
      // //  console.log('环信开始连接-home')
      // this.startTimer()
      const options = {
        apiUrl: WebIM.config.apiURL,
        user: this.shareData.imUserInfo.user.username,
        accessToken: this.shareData.imUserInfo.access_token,
        appKey: WebIM.config.appkey
      }
      const vm = this
      WebIM.conn.open(options)
      WebIM.conn.listen({
        onOpened: function (message) {
          // 连接成功回调
          vm.loading = false
          // console.log('环信连接成功-home', message)
          // console.log('登陆环信8', vm.shareData.imUserInfo)
        },
        onClosed: function (message) {
          vm.loading = true
          // console.log('环信连接失败-home-onClosed', message)
          // console.log('登陆环信6', vm.shareData.imUserInfo)
          // vm.$message.error('您在其他地方登录帐号，请重新登录', '')
          // if (message && message.type === 206) {
          //   vm.showLoginAnother()
          // }
        },
        onError: function (error) {
          //  console.log('环信异常-home-onError', error)
          //  console.log('登陆环信7', vm.shareData.imUserInfo)
          if (error && error.type === 206) {
            vm.showLoginAnother()
          }
        }
      })
    }
  },
  beforeRouteEnter (to, from, next) {
    if (to.name === 'HomePage') {
      next((vm) => {
        vm.startTimer()
      })
    }
  },
  beforeRouteLeave (to, from, next) {
    if (from.name === 'HomePage') {
      clearInterval(this.timer)
      this.timer = null
      next()
    }
  }
}
</script>

<style scoped lang="less">
ul, li {
  list-style: none;
  padding: 0;
  margin: 0;
}

.cointainer {
  min-width: 1024px;
  max-width: 1680px;
  margin: 0 auto;
  box-sizing: border-box;

  @media (min-width: 1441px) {
    .cointainer {
      padding: 80px;
    }
  }
  @media (min-width: 1200px) and (max-width: 1440px) {
    .cointainer {
      padding: 32px;
    }
  }
  @media (max-width: 1199px) {
    .cointainer {
      padding: 24px;
    }
  }

  //上次备考 待办事项
  .top {
    height: 204px;
    width: 100%;
    display: flex;

    .leftImg {
      //display: block;
      flex: 1;
      width: 100%;
      height: 204px;
      background: url('../../assets/homepage/home-last.png') no-repeat center center;
      background-size: 100% 100%;

      .top {
        width: 100%;
        height: 200px;
        padding: 30px;
        //  background: #fff;
        display: block;

        .teacher {
          color: #fff;
          font-size: 24px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
        }

        .speak {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #fff;
          line-height: 20px;
          margin-top: 10px;
          font-weight: 400;
        }

        .textClassName {
          //width: 60px;
          // height: 40px;
          // line-height: 80px;
          font-weight: 400;
          margin-top: 14px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #fff;

        }

        .prePareClass {
          display: flex;
          margin-top: 14px;

          .className {
            cursor: pointer;
            display: inline-block;
            //margin-left: 20px;
            // margin-top: 10px;
            width: 368px;
            height: 32px;
            line-height: 32px;
            // background: url('../../assets/teacherRoad/01.png') no-repeat;
            // background-size: 100% 100%;
            background: linear-gradient(90deg, #FDE47F 0%, #FCCA00 100%);
            box-shadow: 0px 2px 4px 0px rgba(47, 139, 85, 0.4);
            border-radius: 16px;
            position: relative;

            .name {
              font-size: 14px;
              color: #000000;
              position: absolute;
              left: 30px;
              font-weight: 600;
              display: inline-block;
              width: 190px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }

            .goOn {
              font-size: 12px;
              color: rgba(0, 0, 0, 0.6);
              opacity: .8;
              position: absolute;
              right: 40px;
              font-weight: 400;
            }

            .img {
              width: 12px;
              height: 12px;
              position: absolute;
              right: 20px;
              top: 10px;
            }
          }
        }
      }
    }

    .right {
      margin-left: 20px;
      flex: 1;
      width: 100%;
      height: 204px;
      background: #fff;
      border-radius: 6px;

      .title {
        margin-left: 24px;
        margin-top: 20px;

        .tit {
          font-size: 18px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #000000;
          line-height: 28px;
        }
      }

      .bot {
        //width: 640px;
        height: 204px;
        display: flex;
        padding: 20px;
        cursor: pointer;

        .left, .right {
          flex: 1;
          height: 112px;
          //text-align: center;
          .img {
            background-size: contain;
            height: 112px;
          }

          .num {
            font-size: 40px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: @primary-color;
            line-height: 30px;
            margin-top: 20px;
            margin-left: 32px;
          }

          .text {
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #000000;
            line-height: 20px;
            margin-top: 20px;
            margin-left: 32px;
          }
        }

        .left {
          //border-right: 1px solid #E6DDD0;
          background: url('../../assets/homepage/home-queation-bg.png') no-repeat;
          background-size: 100% 100%;
          position: relative;
          .img {
            position: absolute;
            right: 0px;
            bottom: 0px;
            z-index: 0;
            max-width: 160px;
            height: auto;
          }

          .num {
            color: #AF7246;
          }

          .text {
            color: #AF7246;
          }
        }

        .right {
          background: url('../../assets/homepage/home-reply-bg.png') no-repeat;
          background-size: 100% 100%;
          margin-left: 20px;
          position: relative;
          .img {
            position: absolute;
            right: 0px;
            bottom: 0px;
            z-index: 0;
            max-width: 160px;
            height: auto;
          }
          .num {
            color: #167168;
          }

          .text {
            color: #167168;
          }
        }
      }
    }
  }

  //任务和习题
  .task-info {
    width: 100%;
    //background: #F1F0F0;
    margin-top: 20px;
    border-radius: 5px;
    // padding: 20px 30px;

    .title {
      display: flex;

      .title-t {
        color: #333;
        font-size: 18px;
        font-weight: 600;
      }

      .title-s {
        margin-left: auto;

        .span {
          display: inline-block;
          // padding: 5px 10px;
          color: #867D7B;
          background: #F1F0F0;
          border-radius: 2px;
          font-size: 12px;
          text-align: center;
          width: 80px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          cursor: pointer;
          margin-left: 10px;
        }
      }
    }

    .book-name {
      line-height: 30px;
      color: #999;
      font-size: 14px;
      width: 180px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .task-detail {
      display: flex;

      .detail-l {
        // flex: 12;
        flex: 1;
        background: #fff;
        border-radius: 6px;

        .d-title {
          color: #333;
          font-size: 16px;
          font-weight: 600;
          margin: 20px;
          //display: flex;

          .text {
            //width: 48px;
          }

          .task-name {
            justify-content: space-between;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            width: 320px;
            display: inline-block;
          }

          .title-s {
            float: right;
          }
        }

        .d-table {
          // width: 80%;
          min-height: 320px;
          margin-top: 10px;
          text-align: center;

          .chart_stack {
            width: 560px;
            height: 430px;
            margin: 20px auto 0 auto;
          }

          img {
            width: 220px;
            height: 220px;
          }

          .fbrw {
            color: @primary-color;
            cursor: pointer;
          }

          .task-n {
            color: @primary-color;
          }

          /deep/ .ant-table-thead > tr > th,
          .ant-table-tbody > tr > td {
            padding: 5px;
            text-align: center;
          }

          /deep/ .ant-table-tbody > tr > td {
            padding: 5px;
            text-align: center;
          }
        }
      }

      .detail-r {
        //flex: 12;
        flex: 1;
        margin-left: 20px;
        background: #fff;
        border-radius: 6px;

        .d-title {
          color: #333;
          font-size: 16px;
          font-weight: 600;
          padding: 20px;
          //padding-left: 20px;
          // margin-top: 10px;
          // display: flex;

          .text {
            //width: 48px;
            .title-s {
              float: right;
            }
          }

          .task-name {
            justify-content: space-between;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            width: 320px;
            display: inline-block;
          }
        }

        .chart_circle {
          width: 560px;
          height: 400px;
          margin: 20px auto 0 auto;
        }

        .d-table {
          // padding-left: 20px;
          // width: 80%;
          margin-top: 10px;
          text-align: center;

          img {
            width: 220px;
            height: 220px;
          }

          .fbrw {
            color: @primary-color;
            cursor: pointer;
          }

          .task-n {
            color: @primary-color;
          }

          /deep/ .ant-table-thead > tr > th,
          .ant-table-tbody > tr > td {
            padding: 5px;
            text-align: center;
          }

          /deep/ .ant-table-tbody > tr > td {
            padding: 5px;
            text-align: center;
          }
        }
      }
    }

    .more-img {
      width: 12px;
      height: 12px;
      margin-top: -2px;
    }

    .xs {
      color: #867D7B;
      font-size: 14px;
      font-weight: normal;
      cursor: pointer;
    }
  }

  // 班级表现
  .class-performance {
    //width: 1240px;
    min-height: 204px;
    margin-top: 20px;
    background-color: #fff;
    padding: 15px 20px;
    border-radius: 6px;

    .performance-top {
      display: flex;
      height: 30px;
      width: 100%;

      .bx {
        color: #333;
        font-size: 18px;
        font-weight: 600;
      }

      .bx-r {
        margin-left: auto;
        padding-top: 5px;
        cursor: pointer;

        .class-list {
          float: left;

          span {
            display: inline-block;
            // width: 70px;
            height: 24px;
            line-height: 24px;
            border-radius: 2px;
            text-align: center;
            color: #867d7b;
            font-size: 12px;
            padding-left: 5px;
            padding-right: 5px;
            cursor: pointer;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            z-index: 99;
          }

          .currentClass {
            background: @primary-color;
            color: #fff;
          }

          .normalClass {
            background: #f1f0f0;
            color: #867d7b;
          }

          .class-img {
            margin-left: 5px;
            margin-right: 15px;
            margin-top: -16px;
            cursor: pointer;
          }
        }

        .xs {
          color: #867D7B;
          font-size: 14px;
        }

        .more-img {
          width: 12px;
          height: 12px;
          margin-top: -2px;
        }
      }
    }

    .performance-bottom {
      display: flex;

      .behavioral-path {
        flex: 12;

        .behaviourLoadUl {
          display: flex;
          margin-top: 10px;

          .beLi {
            width: 90px;
            height: 24px;
            line-height: 24px;
            background: #f6f6f6;
            font-size: 12px;
            color: #000;
            margin-right: 20px;
            text-align: center;
            cursor: pointer;
            border-radius: 12px;
          }
        }

        .beactiveLi {
          background: @primary-color;
          color: #fff;
          width: 90px;
          margin-right: 20px;
          height: 24px;
          line-height: 24px;
          font-size: 12px;
          text-align: center;
          cursor: pointer;
          border-radius: 12px;
        }

        .chart_bar {
          width: 550px;
          height: 400px;
          margin: 20px auto 0px auto;
        }

        .xw {
          text-align: center;
          font-weight: 600;
          color: #000000;
        }
      }
    }

    .performance-empty {
      min-height: 300px;
      text-align: center;
      margin: auto;

      img {
        width: 220px;
        height: 220px;
      }

      span {
        text-align: center;
      }
    }

    .learning-type {
      flex: 12;
      margin-left: 20px;

      .line {
        width: 800px;
        height: 400px;
        margin: 50px auto 0px auto;
        //float: right;
      }

      .xw {
        text-align: center;
        font-weight: 600;
        color: #000000;
      }
    }
  }

}

// 蜗牛视频文章
.videoBot {
  //width: 100%;
  margin: 20px auto;
  // display: flex;

  .left, .right1 {
    // width: 1240px;
    width: 100%;
    background: #fff;
    padding: 20px 30px;
    border-radius: 6px;

    .title {
      height: 40px;
      position: relative;

      .tit {
        position: absolute;
        left: 0px;
        top: 0px;
        font-size: 18px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #000000;
        line-height: 28px;
      }

      .more {
        position: absolute;
        right: 0px;
        top: 5px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
        line-height: 20px;
        cursor: pointer;
      }
    }
  }

  .left {
    //.content {
    //  font-family: PingFangSC-Regular, PingFang SC;
    //  display: flex;
    //  flex-wrap: nowrap;
    //
    //  li {
    //    margin-right: 25px;
    //    width: 120px;
    //    height: 92px;
    //    background: #f6f6f6;
    //    text-align: center;
    //    padding: 10px 0px;
    //    cursor: pointer;
    //    border-radius: 8px;
    //
    //    .readText {
    //      height: 30px;
    //      line-height: 30px;
    //      font-weight: 400;
    //      color: #000000;
    //      line-height: 26px;
    //
    //    }
    //
    //    .look {
    //      cursor: pointer;
    //      width: 50px;
    //      height: 28px;
    //      border-radius: 2px;
    //      border: 1px solid @primary-color;
    //      margin: 0 auto;
    //      margin-top: 10px;
    //      color: @primary-color;
    //      font-size: 12px;
    //      padding: 4px;
    //    }
    //
    //    &:last-child {
    //      margin-right: 0px;
    //    }
    //  }
    //}

    .activeList {
      margin-top: 10px;
      display: flex;
      flex-wrap: wrap;
      // min-height: 500px;

      .activeLi {
        width: calc(25% - 10px);
        height: 310px;
        margin: 10px 10px 0px 0px;
        box-shadow: 0px 2px 20px 0px rgba(219, 206, 188, 0.3);
        border-radius: 8px;

        .imgDetail {
          height: 160px;
          position: relative;

          .imgTop {
            width: 100%;
            height: 100%;
            display: block;
            border-radius: 8px 8px 0px 0px;
          }

          .beginStaus {
            display: inline-block;
            width: 76px;
            height: 24px;
            background: url('../../assets/teacherRoad/08.png') no-repeat;
            background-size: 100% 100%;
            position: absolute;
            right: 0px;
            top: 0px;
            text-align: center;
            line-height: 24px;
            color: #fff;
          }
        }

        .activeDesc {
          margin-top: 10px;
          padding: 0px 10px;

          .title {
            display: inline-block;
            width: 230px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: pre-wrap;
            height: 50px;
            font-size: 16px;
            font-family: AlibabaPuHuiTi-Medium, AlibabaPuHuiTi;
            font-weight: 500;
            color: #000000;
            line-height: 26px;
          }

          .freeImg {
            width: 25px;
            height: 20px;
            margin-top: 2px;
            float: right;
          }

          .titleName {
            height: 35px;
            font-size: 12px;
            font-family: AlibabaPuHuiTi-Regular, AlibabaPuHuiTi;
            font-weight: 400;
            color: #000000;

            overflow: hidden;
            text-overflow: ellipsis;
          }

          .free {
            color: #a3af90;
            font-size: 14px;
            float: right;
            margin-top: 4px;
          }

          .watchNum {
            height: 18px;
            font-size: 14px;
            font-family: AlibabaPuHuiTi-Regular, AlibabaPuHuiTi;
            font-weight: 400;
            color: #999;
            line-height: 18px;
            margin-left: 5px;
          }

          .watchNow {
            height: 24px;
            border: 1px solid @primary-color;
            border-radius: 4px;
            font-weight: 400;
            color: #fff;
            background-color: @primary-color;
            font-size: 12px;
            line-height: 24px;
            text-align: center;
            float: right;
          }
        }
      }

      .activeLiLock {
        width: calc(25% - 10px);
        height: 310px;
        margin: 10px 10px 0px 0px;
        box-shadow: 0px 2px 20px 0px rgba(219, 206, 188, 0.3);

        .imgDetail {
          height: 160px;
          position: relative;

          .imgTop {
            width: 100%;
            height: 100%;
            display: block;
            filter: contrast(0.4);
          }

          .beginStaus {
            display: inline-block;
            width: 76px;
            height: 24px;
            background: url('../../assets/teacherRoad/08.png') no-repeat;
            background-size: 100% 100%;
            position: absolute;
            right: 0px;
            top: 0px;
            text-align: center;
            line-height: 24px;
            color: #fff;
          }
        }

        .activeDesc {
          margin-top: 10px;
          padding: 0px 10px;

          .title {
            display: inline-block;
            width: 230px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: pre-wrap;
            height: 50px;
            font-size: 16px;
            font-family: AlibabaPuHuiTi-Medium, AlibabaPuHuiTi;
            font-weight: 500;
            color: #000000;
            line-height: 26px;
          }

          .freeImg {
            width: 25px;
            height: 20px;
            margin-top: 2px;
            float: right;
          }

          .titleName {
            height: 35px;
            font-size: 12px;
            font-family: AlibabaPuHuiTi-Regular, AlibabaPuHuiTi;
            font-weight: 400;
            color: #000000;

            overflow: hidden;
            text-overflow: ellipsis;
          }

          .free {
            color: #a3af90;
            font-size: 14px;
            float: right;
            margin-top: 4px;
          }

          .watchNum {
            height: 18px;
            font-size: 14px;
            font-family: AlibabaPuHuiTi-Regular, AlibabaPuHuiTi;
            font-weight: 400;
            color: #999;
            line-height: 18px;
            margin-left: 5px;
          }

          .watchNow {
            height: 24px;
            border: 1px solid @primary-color;
            border-radius: 4px;
            font-weight: 400;
            color: @primary-color;
            font-size: 12px;
            line-height: 24px;
            text-align: center;
            float: right;
          }

          .watchNowLock {
            height: 24px;
            border: 1px solid #999;
            border-radius: 4px;
            font-weight: 400;
            color: #999;
            font-size: 12px;
            line-height: 24px;
            text-align: center;
            float: right;
          }
        }

        .lock {
          opacity: 1;
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          width: 30px;
          height: 30px;
        }
      }
    }
  }

  .right1 {
    margin-top: 20px;
    width: 100%;
    // height: 200px;
    background: #fff;

    .contentUl {
      .ulLi {
        position: relative;
        display: block;
        padding-bottom: 10px;

        .tb {
          left: 0px;
          top: 5px;
          width: 10px;
          height: 10px;
        }

        .kb {
          position: absolute;
          left: 20px;
          top: 2px;
          color: #999;
          font-size: 12px;
        }

        .text {
          position: absolute;
          display: inline-block;
          left: 70px;
          font-size: 14px;
          color: #000;
          width: 300px;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
        }

        .author {
          position: absolute;
          //width: 80px;
          height: 20px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          right: 70px;
          top: 2px;
          font-size: 12px;
          color: #999999;
        }

        .look {
          position: absolute;
          right: 0px;
          display: inline-block;
          width: 50px;
          height: 22px;
          line-height: 18px;
          background: #FFFFFF;
          border-radius: 2px;
          border: 1px solid @primary-color;
          text-align: center;
          color: @primary-color;
          font-size: 12px;
          padding: 2px;
          cursor: pointer;
        }
      }

      // 蜗牛文章
      .bookDetail {
        cursor: pointer;
        margin-top: 15px;
        border-bottom: 1px solid #F0F0F0;

        .arcticle {
          display: flex;

          .arcicle-icon {
            height: 90px;
            width: 90px;
            margin-left: 10px;
            margin-top: 12px;
            margin-bottom: 10px;
            border-radius: 50%;
          }

          .arcticle-detail {
            font-size: 16px;
            font-family: AlibabaPuHuiTi-Medium, AlibabaPuHuiTi;
            font-weight: 500;
            color: #333;
            line-height: 32px;
            margin-top: 10px;
            margin-left: 10px;

            .title {
              font-size: 16px;
              font-family: AlibabaPuHuiTi-Medium, AlibabaPuHuiTi;
              font-weight: 500;
              color: #333;
              line-height: 32px;
              height: 32px;
              margin-left: 10px;
            }

            &:hover {
              .title {
                color: @primary-color;
              }

            }

            .author {
              .userPhoto {
                width: 15px;
                height: 15px;
                margin-left: 10px;
              }

              .userName {
                font-size: 12px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #999999;
                margin-left: 5px;
              }
            }

            .time {
              .userPhoto {
                width: 15px;
                height: 15px;
                margin-left: 10px;
              }

              .date {
                margin-left: 4px;
                font-size: 12px;
                font-family: AlibabaPuHuiTi-Regular, AlibabaPuHuiTi;
                font-weight: 400;
                color: #999999;
              }

            }

          }
        }
      }

      .bookDetailLock {
        cursor: pointer;
        margin-top: 15px;
        border-bottom: 1px solid #F0F0F0;
        position: relative;

        .arcticle {
          display: flex;

          .arcicle-icon {
            height: 90px;
            width: 90px;
            margin-left: 10px;
            margin-top: 12px;
            margin-bottom: 10px;
            border-radius: 50%;
          }

          .arcticle-detail {
            font-size: 16px;
            font-family: AlibabaPuHuiTi-Medium, AlibabaPuHuiTi;
            font-weight: 500;
            color: #333;
            line-height: 32px;
            margin-top: 10px;
            margin-left: 10px;

            .title {
              font-size: 16px;
              font-family: AlibabaPuHuiTi-Medium, AlibabaPuHuiTi;
              font-weight: 500;
              color: #333;
              line-height: 32px;
              height: 32px;
              margin-left: 10px;
            }

            &:hover {
              .title {
                color: @primary-color;
              }

            }

            .author {
              .userPhoto {
                width: 15px;
                height: 15px;
                margin-left: 10px;
              }

              .userName {
                font-size: 12px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #999999;
                margin-left: 5px;
              }
            }

            .time {
              .userPhoto {
                width: 15px;
                height: 15px;
                margin-left: 10px;
              }

              .date {
                margin-left: 4px;
                font-size: 12px;
                font-family: AlibabaPuHuiTi-Regular, AlibabaPuHuiTi;
                font-weight: 400;
                color: #999999;
              }

            }

          }
        }

        .overlay {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-color: rgba(0, 0, 0, 0.3); /* 透明灰色蒙层 */
          border-radius: 6px;
        }

        .lock-icon {
          position: absolute;
          height: 30px;
          width: 30px;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          /* 根据实际需要设置锁图标的样式 */
        }
      }

      .no-text {
        text-align: center;
      }
    }
  }

}

.radio {
  display: block;
  height: 30px;
  lineHeight: 30px;
  margin-left: 130px;
}

.f-del {
  display: flex;
  width: 180px;
  margin: 20px auto 0;

  .f-c {
    background: #FFFFFF;
    border-radius: 4px;
    border: 1px solid #DBD1CD;
    color: #867D7B;
    height: 30px;
    text-align: center;
    width: 70px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    line-height: 30px;
    text-align: center;
    margin: auto;
    cursor: pointer;
  }

  .f-s {
    background: @primary-color;
    color: #fff;
    border-radius: 4px;
    height: 30px;
    text-align: center;
    width: 70px;
    line-height: 30px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    text-align: center;
    margin: auto;
    cursor: pointer;
  }
}
</style>
